var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegulatorFilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2998 6.5H19.4998V15.5C19.4998 15.5163 19.4998 15.5327 19.4998 15.549C19.4999 15.9306 19.4999 16.3015 19.4588 16.6075C19.4125 16.9523 19.2995 17.3459 18.9726 17.6728C18.6457 17.9997 18.2521 18.1126 17.9073 18.159C17.6013 18.2001 17.2304 18.2001 16.8488 18.2C16.8325 18.2 16.8161 18.2 16.7998 18.2H12.2998V6.5ZM14.0998 8.3V16.4H16.7998C17.2495 16.4 17.4962 16.3981 17.6674 16.3751C17.6696 16.3748 17.6718 16.3745 17.674 16.3742C17.6743 16.372 17.6746 16.3698 17.6749 16.3676C17.6979 16.1964 17.6998 15.9497 17.6998 15.5V8.3H14.0998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50001 6.5H8.7V18.2H4.20001C4.18367 18.2 4.16734 18.2 4.15104 18.2C3.76938 18.2001 3.39847 18.2001 3.09254 18.159C2.74766 18.1126 2.35411 17.9997 2.02722 17.6728C1.70033 17.3459 1.58736 16.9523 1.54099 16.6075C1.49986 16.3015 1.49993 15.9306 1.50001 15.549C1.50001 15.5327 1.50001 15.5163 1.50001 15.5V6.5ZM3.30001 8.3V15.5C3.30001 15.9497 3.30192 16.1964 3.32494 16.3676C3.32524 16.3698 3.32553 16.372 3.32583 16.3742C3.32797 16.3745 3.33016 16.3748 3.33239 16.3751C3.50356 16.3981 3.7503 16.4 4.20001 16.4H6.90001V8.3H3.30001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8999 6.5H14.0999V18.2H6.8999V6.5ZM8.6999 8.3V16.4H12.2999V8.3H8.6999Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15104 2.00001C4.16735 2.00001 4.18367 2.00001 4.20001 2.00001H16.8C16.8163 2.00001 16.8327 2.00001 16.849 2.00001C17.2306 1.99993 17.6015 1.99986 17.9075 2.04099C18.2523 2.08736 18.6459 2.20033 18.9728 2.52722C19.2997 2.85411 19.4126 3.24766 19.459 3.59254C19.5001 3.89847 19.5001 4.26939 19.5 4.65106C19.5 4.66736 19.5 4.68368 19.5 4.70001V8.3H1.50001V4.70001C1.50001 4.68367 1.50001 4.66735 1.50001 4.65104C1.49993 4.26938 1.49986 3.89847 1.54099 3.59254C1.58736 3.24766 1.70033 2.85411 2.02722 2.52722C2.35411 2.20033 2.74766 2.08736 3.09254 2.04099C3.39847 1.99986 3.76938 1.99993 4.15104 2.00001ZM3.32583 3.82583C3.32554 3.82797 3.32524 3.83016 3.32494 3.83239C3.30192 4.00356 3.30001 4.2503 3.30001 4.70001V6.50001H17.7V4.70001C17.7 4.2503 17.6981 4.00356 17.6751 3.83239C17.6748 3.83016 17.6745 3.82797 17.6742 3.82583C17.672 3.82553 17.6698 3.82524 17.6676 3.82494C17.4964 3.80192 17.2497 3.80001 16.8 3.80001H4.20001C3.7503 3.80001 3.50356 3.80192 3.33239 3.82494C3.33016 3.82524 3.32797 3.82553 3.32583 3.82583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulatorFilling);
export default __webpack_public_path__ + "static/media/regulator_filling.0cce4c92b72dcd0a85c869e7e616ef2a.svg";
export { ForwardRef as ReactComponent };